/**
    * @description      : 
    * @author           : Saif
    * @group            : 
    * @created          : 04/11/2024 - 23:01:24
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/11/2024
    * - Author          : Saif
    * - Modification    : 
**/
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import CustomModal from "../../Components/CustomModal";
import CustomButton from "../../Components/CustomButton";
import { useGet, usePatch, usePost } from "../../Api";
import { male1 } from "../../Assets/images";
import FormatDateTime from "../../Components/DateFormate";

export const UserDetails = () => {

    const { id } = useParams();
    const [data, setData] = useState({});
    const [userStatus, setUserStatus] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [showModal4, setShowModal4] = useState(false);
    const [historyData, setHistoryData] = useState();
    const [message, setMessage] = useState(false)
    const { ApiData: UseeListingData, loading: UseeListingLoading, error: UseeListingError, get: GetUseeListing } = useGet(`/users/${id}`);
    const { ApiData: StatusUpdateData, loading: StatusUpdateLoading, error: StatusUpdateError, post: GetStatusUpdate } = usePost(`/users/${id}/approve`);
 


    const inActive = () => {
        setShowModal(false)
        setUserStatus({
            ...userStatus,
            status: 0
        })
        setShowModal2(true)

        setTimeout(() => {
            setShowModal2(false)
        }, 1000)
        console.log('status', userStatus)
    }
    const Active = () => {
        setShowModal3(false)
        setUserStatus({
            ...userStatus,
            status: 1
        })
        setShowModal4(true)
        setTimeout(() => {
            setShowModal4(false)
        }, 1000)
        console.log('status', userStatus)
    }

    useEffect(() => {
        if (userStatus.status) {
            GetStatusUpdate(userStatus);
        }
    }, [userStatus])


    useEffect(() => {
        if (StatusUpdateData) {
            GetUseeListing()
        }
    }, [StatusUpdateData])

    useEffect(() => {
        GetUseeListing()
    }, [])


    useEffect(() => {
        if (UseeListingData) {
            setData(UseeListingData)
        }
    }, [UseeListingData])




    return (
        <>
            <DashboardLayout>
                <div className="dashCard mb-4">
                    <div className="row mb-3">
                        <div className="col-12 mb-2">
                            <h2 className="mainTitle">
                                <BackButton />
                                User Details
                            </h2>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="row mb-3 justify-content-end">
                                <div className="col-lg-4 text-end order-1 order-lg-2 mb-3">
                                    <button onClick={() => {
                                        data?.status ? setShowModal(true) : setShowModal3(true)
                                    }} className="notButton primaryColor fw-bold text-decoration-underline">Mark as {data?.status ? 'Inactive' : 'Active'}</button>
                                    <span className={`statusBadge ${data?.status == 1 ? 'statusBadgeActive' : 'statusBadgeInactive'}`}>{data?.status == 1 ? 'Active' : 'Inactive'}</span>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-md-12 mb-4">

                                    <div className="productImages">
                                        <img src={data?.profilePicture ? data?.profilePicture : male1} className="detailPro" />
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">User Name</h4>
                                    <p className="secondaryText">{data?.name}</p>
                                </div>
                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">User Email</h4>
                                    <p className="secondaryText">{data?.email}</p>
                                </div>
                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">User Role</h4>
                                    <p className="secondaryText">{data?.role}</p>
                                </div>
                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Approved by</h4>
                                    <p className="secondaryText">{data?.approved_by}</p>
                                </div>
                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">User Subscription Status</h4>
                                    <p className="secondaryText">{data?.status === 1 ? 'Active' : 'Inactive'}</p>
                                </div>

                           
                            </div>
                        </div>
                    </div>
                </div>

                <CustomModal show={showModal} close={() => { setShowModal(false) }} action={inActive} heading='Are you sure you want to mark this user as inactive?' />
                <CustomModal show={showModal2} success heading='Marked as Inactive' />

                <CustomModal show={showModal3} close={() => { setShowModal3(false) }} action={Active} heading='Are you sure you want to mark this user as Active?' />
                <CustomModal show={showModal4} success heading='Marked as Active' />
            </DashboardLayout>
        </>
    );
};

